const XAPI_PATH = "XAPI_PATH";

export const setXAPIPath = (value) => {
    localStorage.setItem(XAPI_PATH, value);
};

export const getXAPIPath = () => {
    return localStorage.getItem(XAPI_PATH);
};
